<template>
  <card>
    <template slot="header">
      <h3 class="card-title">
        {{title}}
        <button @click="addAction" class="btn btn-success pull-right" v-if="addEnabled">
          <font-awesome-icon icon="plus"></font-awesome-icon>
          Add
        </button>
      </h3>
    </template>
    <l-table :actions="actions"
             :columns="columns"
             :data="tableData"
             @delete="deleteRecord">

    </l-table>
    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
      </div>
      <l-pagination class="pagination-no-border"
                    v-model="pagination.currentPage"
                    :page-count="pagination.pages"
                    :per-page="pagination.perPage">
      </l-pagination>
    </div>
  </card>
</template>

<script>
import {
  Pagination as LPagination,
  Table as LTable
} from "../../index";

export default {
  name: "SimpleTable",

  components: {
    LTable,
    LPagination
  },

  props: {
    title: {
      type: String,
      required: true
    },
    actions: Array,
    columns: Array,
    url: {
      type: String,
      required: true
    },
    isEntity: {
      type: Boolean,
      default: false,
    },
    addEnabled: {
      type: Boolean,
      default: false
    },
    addUrl: {
      type: String,
      default: "add"
    }
  },

  watch: {
    "pagination.currentPage": function paginationCurrentPage() {
      this.refreshData(this.pagination.currentPage);
    }
  },

  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },

  data() {
    return {
      tableData: [],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0,
        pages: 0
      }
    };
  },

  methods: {
    async refreshData(page = 1) {
      const response = await this.axios.get(`${this.urlBuilder(page)}size=${this.pagination.perPage}`);
      const { data } = response;
      this.tableData = data.data;
      this.pagination.total = data.count;
      this.pagination.perPage = data.size;
      this.pagination.currentPage = data.page;
      this.pagination.pages = data.pages;
      if (this.pagination.currentPage > this.pagination.pages) {
        this.pagination.currentPage -= 1;
        this.refreshData(this.pagination.currentPage);
      }
    },
    urlBuilder(page) {
      return this.isEntity
        ? `${this.url}/page/${page}?`
        : `${this.url}?page=${page}&`;
    },
    async deleteRecord(id) {
      const url = `${this.url}/${id}`;

      try {
        await this.axios.delete(url);
        this.$emit("clearScreen");
        this.refreshData(this.pagination.currentPage);
      } catch (e) {
        this.$notify({
          type: "danger",
          message: e.message
        });
      }
    },
    addAction() {
      this.$router.push(`${this.$route.path}/${this.addUrl}`);
    }
  },

  beforeMount() {
    this.refreshData();
  }
};
</script>

<style scoped>

</style>
